import  {combineReducers} from "redux";
import {dateReducer} from "./dateReducer";


export const reducers = combineReducers({
    data:dateReducer
})